(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/reducers/competition-result-reducer.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/reducers/competition-result-reducer.js');
"use strict";

const _RTK = RTK,
  combineReducers = _RTK.combineReducers;
const _svs$components$marke = svs.components.marketplaceCompetition.services.reducers,
  personalResultReducer = _svs$components$marke.personalResultReducer,
  highscoreResultReducer = _svs$components$marke.highscoreResultReducer;
const competitionResultReducer = combineReducers({
  personalResult: personalResultReducer,
  highscore: highscoreResultReducer
});
setGlobal('svs.components.marketplaceCompetition.services.reducers.competitionResultReducer', competitionResultReducer);

 })(window);